import { Icon } from "./icon";

/** The summary above a form after a failed check: it names the fields, each a link that focuses it. */
export function ErrorSummary({
  fields,
}: Readonly<{ fields: readonly Readonly<{ id: string; label: string }>[] }>) {
  if (fields.length === 0) return null;
  return (
    <div
      className="rounded-sm border border-destructive-border bg-destructive-soft p-3.5 text-sm leading-6 text-destructive"
      role="alert"
    >
      <p className="m-0 flex items-center gap-2 font-semibold">
        <Icon name="alert-02" className="size-4 shrink-0" />
        {fields.length === 1
          ? "1 field needs attention:"
          : `${fields.length} fields need attention:`}
      </p>
      <ul className="mt-1 mb-0 list-disc pl-10">
        {fields.map((field) => (
          <li key={field.id}>
            <a
              href={`#${field.id}`}
              className="inline-flex min-h-11 items-center underline underline-offset-2 compact:min-h-8"
              onClick={(event) => {
                event.preventDefault();
                document.getElementById(field.id)?.focus();
              }}
            >
              {field.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
